<div class="form-typography padding-medium" *ngIf="intent && intent.answer === 'start-claim'">
  <div class="open-form-info padding-medium">
    <div class="flex flex-justify-center">
      <div class="flex-shrink margin-right-small">
        <open-svg-icon name="management-claim" class="small"></open-svg-icon>
      </div>
      <div class="flex flex-column flex-justify-center">
        <p class="margin-top-xxsmall">Online claims lodgement is coming soon — watch this space!</p>
      </div>
    </div>
  </div>
</div>
<div class="grid align-center padding-medium">
  <div class="cell cell-large-col-span-6 cell-medium-col-span-8 margin-bottom-large">
    <h1 class="margin-bottom-large">{{ title }}</h1>
    <p class="margin-bottom-medium" *ngIf="subTitle">{{ subTitle }}</p>
    <button mat-flat-button color="primary" (click)="call()">{{ buttonText }}</button>
  </div>
  <div class="cell cell-large-col-span-6 cell-medium-col-span-8 margin-bottom-large padding-medium info-box">
    <h2 class="margin-bottom-medium">Helpful information to have ready:</h2>
    <div class="flex margin-bottom-small" *ngFor="let info of infoList, index as i">
      <div class="flex-shrink margin-right-small">
        <open-svg-icon [name]="info.icon" class="small"></open-svg-icon>
      </div>
      <div *ngIf="info.type === 'policy'">
        <p class="margin-top-xxsmall" *ngIf="!info.policyNumber">{{ info.text }}</p>
        <ng-container *ngIf="info.policyNumber">
          <h3 class="text-xsmall">{{ info.text }}</h3>
          <strong>{{ info.policyNumber }}</strong>
        </ng-container>
      </div>
      <div class="flex flex-column flex-justify-center" *ngIf="info.type !== 'policy'">
        <p class="margin-top-xxsmall">{{ info.text }}</p>
      </div>
    </div>
  </div>
</div>
